import { render, staticRenderFns } from "./normalTableCont.vue?vue&type=template&id=2df8d040"
import script from "./normalTableCont.vue?vue&type=script&lang=js"
export * from "./normalTableCont.vue?vue&type=script&lang=js"
import style0 from "./normalTableCont.vue?vue&type=style&index=0&id=2df8d040&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports